import { useConfigContext } from 'config/ui/ConfigContext'

import { getShipperBusiness, type Shipment, type ShipperBusiness } from '../../domain/Shipment'

export function useShipmentChargesPermissions(shipment: Shipment | undefined) {
  const config = useConfigContext()

  const accessorialsEnabledByShipperBusiness: Record<ShipperBusiness, boolean> = {
    BROKERAGE: config.enableShipmentChargesForBrokerage.toBoolean(),
    MTC: true,
    SAAS: true,
    FBM: config.enableShipmentChargesForFbm.toBoolean(),
  }

  const isEnabledByBusiness = accessorialsEnabledByShipperBusiness[getShipperBusiness(shipment)]

  return { isShipmentChargesEnabled: isEnabledByBusiness }
}
